import Axios from "axios";

export const GetCodfrs = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/CodFrs?&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "GET_CODFRS", payload: response.data });
    });
  };
};
